import numeral from "lib/numeral";
import * as urlUtils from "../../../../core/utils/url";
import {asBoolean, asNumber, asString, element} from "../../../../core/utils/var";

export class Settings {
	constructor(data) {
		this._data = {...data}; // clone to avoid external modification

		if (typeof(numeral) !== 'undefined') {
			numeral.localeData().currency.symbol = this.currency;
		}
	}

	/** @return {string} */
	get baseUrl() {
		return asString(element(this._data, 'base_url', ''));
	}

	/** @return {string} */
	get shopUrl() {
		return asString(element(this._data, 'shop_url', ''));
	}

	/** @return {string} */
	get catalogApiUrl() {
		return asString(element(this._data, 'api_url', this.shopUrl));
	}

	/** @return {string} */
	get searchApiUrl() {
		return asString(element(this._data, 'search_api_url', this.shopUrl));
	}

	/** @return {string} */
	get imgUrl() {
		return asString(element(this._data, 'img_url', ''));
	}

	/** @return {string} */
	get currency() {
		return asString(element(this._data, 'currency', 'EUR'));
	}

	/** @return {number} */
	get currencyRate() {
		return asNumber(element(this._data, 'currency_rate'), 1);
	}

	/** @return {boolean} */
	get isAdmin() {
		return asBoolean(element(this._data, 'is_admin'));
	}

	/** @return {boolean} */
	get isGerman() {
		return !!window.IS_GERMAN;
	}

	/**
	 * @return {boolean}
	 */
	get useFavorites() {
		return asBoolean(element(this._data, 'use_favorites'));
	}

	/**
	 * Use offer url as product url
	 * @return {boolean}
	 */
	get useOfferUrl() {
		return asBoolean(this._data['use_offer_url']);
	}

	/**
	 * Format for numeral library
	 * @return {string}
	 */
	get priceFormat() {
		return this.currencyRate === 1 ? '0,0.00 $' : '0,0 $';
	}

	/** @return {boolean} */
	get debug() {
		return asBoolean(element(this._data, 'debug'));
	}

	/**
	 * @param {number} price
	 * @return {number}
	 */
	convertPrice(price) {
		return asNumber(price)*this.currencyRate;
	}

	getCategoryUrl(categorySlug, subcategorySlug = null) {
		return urlUtils.joinPath(this.shopUrl, categorySlug, subcategorySlug);
	}

	getProductUrl(productUri) {
		return urlUtils.joinPath(this.shopUrl, productUri);
	}

	getImageUrl(path, dir = 'full/') {
		if (urlUtils.isAbsolute(path)) {
			return path;
		}
		return urlUtils.joinPath(this.imgUrl, dir, path);
	}

	getPreviewImgageUrl(path) {
		return this.getImageUrl(path, 'preview/');
	}

	getShopUrl(shopSlug) {
		return urlUtils.siteUrl('shops', shopSlug);
	}

	getOfferUrl(offerId) {
		return urlUtils.siteUrl('shop/relocate', offerId);
	}
}



// WEBPACK FOOTER //
// ./modules/shop/common/model/settings.js